import {ApiClient} from './api'

export class AdyenOrderService {
    baseUrl = '/api/adyen/order'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async orderCancel(orderNo, customerId) {
        const basketId = localStorage.getItem('basketid')
        if (orderNo && customerId && basketId) {
            if (orderNo?.indexOf('ERROR') !== -1) {
                throw new Error('invalidOrder')
            }
            const res = await this.apiClient.post({
                path: '/cancel',
                body: JSON.stringify({
                    orderNo
                }),
                headers: {
                    customerid: customerId,
                    basketid: basketId
                }
            })
            const jsonResponse = await res.json()
            if (res.status >= 300) {
                throw new Error(jsonResponse.errorMessage)
            } else {
                return jsonResponse
            }
        }
    }
}
